// plugins/error-handler.js
/* eslint-disable no-console */
/* eslint-disable node/handle-callback-err */

import Vue from 'vue'

export default () => {
  Vue.config.errorHandler = (_err, vm) => {
    const route = vm.$route
    if (['licenses', 'licenses-pro'].includes(route.params.id)) {
      if (process.client) {
        //  vm.$store.commit('cards/deleteSelectedCard', { index: 0, amount: 1 })
        // sessionStorage.clear()
        vm.$store.commit('cards/resetSelectedCards')
        vm.$store.commit('steps/setReachedStepNumber', 0)
        vm.$store.commit('cards/setCurrentStepCards', 'licenses')
        //   window.location.reload()

        // sessionStorage.clear()
        // vm.$store.commit('cards/setCurrentStepCards', 'licenses')
        // vm.$store.commit('steps/setReachedStepNumber', 0)
        // vm.$store.commit('cards/setCurrentStepSelectedCards', 'licenses')
        // window.location.reload()
      }
    }
  }
}
